const Q = require(`q`);
const _ = require(`underscore`);
const to_boolean = require(`../../../convert/to_boolean`);

/**
 * NL类库
 *
 * @module nllib
 */

/**
 * 轮询，等待指定条件
 *
 * @class nllib/src/common/wait_util
 * @static
 *
 * @param {object} pParameter
 * @param {int} pParameter.interval_seconds 轮询时间间隔，单位为秒，默认值为0.5
 * @param {function} pParameter.check 轮询检测方法，方法默认值为
 <div>
 const __default_check = function () {
        return Q.resolve({
            flag: true,
        });
    };
 </div>
 * @param {int} pParameter.max_count 最大轮询次数，默认值为10
 * @param {boolean} pParameter.enable_log 是否输出日志，默认值为false
 * @return {promise} 指定条件第一次符合时的promise
 *
 * @demo src/common/wait_util/1.0.1/demo/index.demo.js
 */
const wait_util = function (pParameter) {
    if (!pParameter) pParameter = {};
    const interval_seconds = pParameter.interval_seconds || 0.5;
    const __check = pParameter.check;
    const max_count = pParameter.max_count || 10;
    const enable_log = to_boolean(pParameter.enable_log, false);

    const __default_check = function () {
        return Q.resolve({
            flag: true,
        });
    };

    const delay = interval_seconds * 1000;

    let check;
    if (_.isFunction(__check)) {
        check = __check;
    } else {
        check = __default_check;
    }

    const defer = Q.defer();

    let i = 1;
    const id_setInterval = setInterval(function () {
        if (i > max_count) {
            clearInterval(id_setInterval);
            defer.reject({
                code: `900`,
                msg: `轮询次数，到达max_count！`,
            });
            return;
        }

        Q.when()
            .then(function () {
                if (enable_log) console.log(`wait_util::第${i}次check:开始`);
                return check();
            })
            .then(function (data) {
                const i_current = i++;
                if (!data) return;

                const flag = data.flag;
                if (enable_log) console.log(`wait_util::第${i_current}次check:结束`, `flag=${flag}`);
                if (!flag) return;

                clearInterval(id_setInterval);

                defer.resolve();
            })
            .catch(function (ex) {
                clearInterval(id_setInterval);
                defer.reject(ex);

                if (!ex) return Q.reject(ex);
                const enable_log_error = !ex.disable_log_error;
                if (!enable_log_error) return Q.reject(ex);
                console.error(ex);
                console.trace();
                if (ex.stack) console.error(ex.stack);
                return Q.reject(ex);
            })
        ;
    }, delay);

    return defer.promise;
};

module.exports = wait_util;
